/** @jsxImportSource @emotion/react */
import { DesktopOutlined, MobileOutlined } from '@ant-design/icons';
import { css } from '@emotion/react';
import { Tabs } from 'antd';

const tabLabelStyle = css`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const items = [
  {
    key: "PC",
    label: (
      <div css={tabLabelStyle}>
        <DesktopOutlined />
        Phiên bản PC
      </div>
    )
  },
  {
    key: "MOBILE",
    label: (
      <div css={tabLabelStyle}>
        <MobileOutlined />
        Phiên bản Mobile
      </div>
    )
  }
];

type AdviceRecommendTabDevicesProps = {
  activeKey?: "PC" | "MOBILE";
  onChange?: (activeKey: "PC" | "MOBILE") => void;
};

export default function AdviceRecommendTabDevices({
  activeKey = "PC",
  onChange = () => {}
}: AdviceRecommendTabDevicesProps) {
  return (
    <Tabs activeKey={activeKey} onChange={(key) => onChange(key as "PC" | "MOBILE")} css={tabStyle}>
      {items.map((item) => (
        <Tabs.TabPane tab={item.label} key={item.key} />
      ))}
    </Tabs>
  );
}

const tabStyle = css`
  .ant-tabs-nav {
    margin-bottom: 0;
  }

  .ant-tabs-tab {
    padding: 6px 8px;
    color: #333;
    border: 1px solid #ccc;
    background-color: #f0f0f0;
  }

  .ant-tabs-tab:not(:first-of-type) {
    margin: 0 0 0 8px !important;
  }

  .ant-tabs-tab-active {
    background-color: var(--blue-dark-color);
    border: 1px solid var(--blue-dark-color);
    .ant-tabs-tab-btn {
      color: #ffffff !important;
    }
  }

  .ant-tabs-ink-bar {
    display: none;
  }

  .ant-tabs-tab:hover {
    color: #333 !important;
  }
`;
